import PropTypes from 'prop-types';
import { Badge, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import React from 'react';

export default function DataProductCard({ product, onHover }) {
    const navigate = useNavigate();
    const desc = product.description;

    return (
        <Card
            className="data-card h-100 border-0 shadow-sm"
            onClick={() => navigate(`/data/products/${product.id}`)}
            role="button"
            tabIndex={0}
            aria-label={`View details for ${product.name}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(`/data/products/${product.id}`);
                }
            }}
            onMouseEnter={() => onHover?.(product.id)}
            onMouseLeave={() => onHover?.(null)}
        >
            <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title className="h6 text-primary mb-0 me-2">
                        {product.name}
                    </Card.Title>
                    {product.product_type && (
                        <Badge
                            bg="warning"
                            text="dark"
                            className="text-uppercase flex-shrink-0"
                        >
                            {product.product_type}
                        </Badge>
                    )}
                </div>
                <Card.Text className="text-body-secondary small flex-grow-1 data-card-desc">
                    {desc}
                </Card.Text>
                <div className="d-flex justify-content-between align-items-center mt-auto">
                    <small className="text-muted">
                        {product.organization || 'Unknown org'}
                    </small>
                    {product.spotlight && (
                        <Badge bg="success" className="fw-normal">
                            {product.spotlight}
                        </Badge>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

DataProductCard.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        product_type: PropTypes.string,
        organization: PropTypes.string,
        spotlight: PropTypes.string,
    }).isRequired,
    /** Called with product ID on mouse enter, null on mouse leave */
    onHover: PropTypes.func,
};
